export const getDisplayedGroupItemIndexes = (page, pageSize, groupByColumnDetailsAndCounts) => {
  const startingItemIndex = (page - 1) * pageSize;
  const endingItemIndex = startingItemIndex + pageSize;

  let startDisplayGroup = 0;
  let endDisplayGroup = 0;
  let totalCount = 0;
  for (let i = 0; i < groupByColumnDetailsAndCounts.length; i++) {
    const { count } = groupByColumnDetailsAndCounts[i];
    if (totalCount <= startingItemIndex) {
      startDisplayGroup = i + 1;
    }
    if (totalCount <= endingItemIndex) {
      endDisplayGroup = i + 1;
    }
    totalCount += count;
    if (totalCount > endingItemIndex) {
      break;
    }
  }
  return {
    startingItemIndex,
    endingItemIndex,
    startDisplayGroup,
    endDisplayGroup,
  };
};

// Ex. 5 items per page, 4 items in first group, 4 items in second group, current page = 2, then startingIdx = 5
// Based on the above return value should be 1, since I rendered 1 of the 4 items from the second group in the first page.
// Total items including current group = 8. startingIdx 5. Subtraction gives us remaining number of items
// Subtracting remaining number of items from current group size will give us proper idx.
export const getIdxInGroupOffset = ({ groupByColumnDetailsAndCounts, currentGroupIdx, startingItemIndex }) => {
  let totalItemsIncludingCurrentGroup = 0;
  for (let i = 0; i < groupByColumnDetailsAndCounts.length; i++) {
    const { count } = groupByColumnDetailsAndCounts[i];
    if (i <= currentGroupIdx) {
      totalItemsIncludingCurrentGroup += count;
    } else {
      break;
    }
  }
  const remainingNumOfItemsInCurrGroup = totalItemsIncludingCurrentGroup - startingItemIndex;
  return groupByColumnDetailsAndCounts[currentGroupIdx].count - remainingNumOfItemsInCurrGroup;
};
